import type { PropsWithChildren, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { AppLoading } from '../marketing/app-loading';
import { loginPathFor, onboardingPathFor } from './redirect';
import { useAuth } from './use-auth';

export function ProtectedRoute({ children }: PropsWithChildren): ReactElement {
  const { activated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <AppLoading />;
  }

  if (!user) {
    // Where they were going comes along, so a link opened signed out — a
    // WhatsApp claim link, a shared session — lands there after sign-in.
    return (
      <Navigate
        replace
        to={loginPathFor(`${location.pathname}${location.search}`)}
      />
    );
  }

  if (!activated) {
    // Signed in, but signup is not finished: the onboarding form first, then
    // on to where they were going.
    return (
      <Navigate
        replace
        to={onboardingPathFor(
          new URLSearchParams({
            redirect: `${location.pathname}${location.search}`,
          }),
        )}
      />
    );
  }

  return <>{children}</>;
}
